import React, { forwardRef, useImperativeHandle } from 'react';
import DatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker';
import { ControllerRenderProps } from 'react-hook-form';
import de from 'date-fns/locale/de';
import moment from 'moment';

type CustomOptions = {
  defaultValue?: Date;
  isMobile?: boolean;
};

export interface CustomDatePickerRef {
  getStateVariable: () => string;
}

const CustomDatePicker = forwardRef<CustomDatePickerRef, ControllerRenderProps & ReactDatePickerProps & CustomOptions>((props, ref) => {
  const { value, onChange, onBlur, name, isMobile, ...rest } = props;

  // Register the 'de' locale for German format
  registerLocale('de', de);

  // Expose the value via ref, so the parent component can access it if needed
  useImperativeHandle(ref, () => ({
    getStateVariable: () => {
      if(value && moment(value, 'DD.MM.YYYY').isValid()) {
        return moment(value, 'DD.MM.YYYY').format('DD.MM.YYYY') 
      } else {
        return ''
      }},
  }));

  const test = moment(value, 'DD.MM.YYYY').toDate()

  return (
    <DatePicker
      {...rest}
      name={name}
      selected={value ? (typeof value === 'string' ? moment(value, 'DD.MM.YYYY').toDate() : value) : null} // Ensure selected is a Date object
      onChange={(date) => onChange(date || undefined)} // Pass onChange to react-hook-form
      onBlur={onBlur}
      clearButtonTitle="Eingabe löschen"
      popperPlacement="top"
      todayButton="Heute"
      dateFormat="dd.MM.yyyy" // Set consistent date format
      locale="de" // Apply the German locale
      dropdownMode="select"
      // Mobile-specific behavior
      peekNextMonth={isMobile}
      showMonthDropdown={isMobile}
      showYearDropdown={isMobile}
      withPortal={isMobile}
    />
  );
});

export default CustomDatePicker;